import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";

export const selectAuthState = (state: RootState) => state.auth;

export const selectIsUserAuthenticated = createSelector(
  selectAuthState,
  (auth) => auth.accessToken
);
export const selectIsLoggingIn = createSelector(
  selectAuthState,
  (auth) => auth.loading
);
export const selectUserId = createSelector(
  selectAuthState,
  (auth) => auth.userId
);
export const selectOrgId = createSelector(
  selectAuthState,
  (auth) => auth.orgId
);
export const selectEmailAddress = createSelector(
  selectAuthState,
  (auth) => auth.emailAddress
);
